import { Site } from './site'
import { AdmSiteConfig } from './siteConfig'

export interface PrebidConfig {
  scopeId: string
  apsAccountId: string
  sites: Site[]
  siteConfigs: AdmSiteConfig[]
}

export interface SitePbjsConfig {
  userSync?: UserSync
  analytics?: Analytics[]
  rendering?: Rendering[]
  realTimeData?: RealTimeData
  /** default value is true, so pbjsConfig or allowLocalStorage undefined means true (managed in kleanad.js and app frontend) */
  allowLocalStorage?: boolean
  targetingBehaviors?: TargetingBehaviors
  schain?: Schain
  outbrain?: Outbrain
  enableTIDs?: boolean
  bidderConfigs?: PbjsBidderConfigs[]
}

//TODO tmu 2024-10-03 most of these are not used, but either they should be or should be removed. Are we using the db entity where this should be used instead ?

export interface ScopePbjsConfig {
  bidderAliases?: BidderAlias[]
  userSync?: UserSync
  schain?: Schain
  s2sConfig?: S2SConfig
}

export interface UserSync {
  userIds?: UserId[]
  [key: string]: any
}

export interface UserId {
  name: string
  params?: Record<string, unknown>
  [key: string]: any
}

export interface Analytics {
  provider: string
  options?: Record<string, unknown>
}

export interface Rendering {
  provider: string
}

export interface DataProvider {
  name: string
  params?: Record<string, unknown>
  storage?: Record<string, unknown>
  waitForIt?: boolean
}

export interface Outbrain {
  bidderUrl: string
  usersyncUrl: string
}
export interface SchainNode {
  asi: string
  sid: string
  hp: number
}

export interface SchainConfig {
  ver: string
  complete: number
  nodes: SchainNode[]
}

export interface Schain {
  validation: string
  config: SchainConfig
}

export interface PbjsBidderConfigs {
  bidders: string[]
  config: BiddersConfig
}

export interface BiddersConfig {
  schain?: Schain
  [keyof: string]: unknown
}

export interface RealTimeData {
  dataProviders?: DataProvider[]
  auctionDelay?: number
}

export interface TargetingBehaviors {
  sendKVTargetings: boolean
  biddersBlackList: string[]
}

export interface BidderAlias {
  bidderLabel: string
  bidderSource: string
}

export interface S2SConfig {
  /** Not stored on a One scope: built per stack from its bidder rule (ADR-0036). */
  bidders?: string[]
  extPrebid?: ExtPrebid
  endpoint: string
  enabled: boolean
  adapter: string
  syncEndpoint: string
}

/** Pubstack's Prebid Server, the transport a One page uses when its scope sets none. */
export const DEFAULT_ADM_S2S_CONFIG: S2SConfig = {
  extPrebid: {
    targeting: {
      includebidderkeys: true,
      includewinners: true,
      durationrangesec: [50],
      preferdeals: false,
      includeformat: true,
    },
    returnallbidstatus: true,
  },
  endpoint: 'https://prebid-server.pbstck.com/openrtb2/auction',
  enabled: true,
  adapter: 'prebidServer',
  syncEndpoint: 'https://prebid-server.pbstck.com/cookie_sync',
}

interface ExtPrebid {
  /** Not stored on a One scope: built per stack from its bidder rule (ADR-0036). */
  aliases?: Record<string, string>
  targeting?: { [key: string]: any }
  cache?: { [key: string]: any }
  returnallbidstatus?: boolean
}
